<template>
    <main class="pd-main">
        <div class="main-content">
            <header class="header no-border">
                <div class="header-bar">
                <h4 class="text-uppercase">Training Courses</h4>
                </div>
            </header>
            <circle-spin class="m-0" v-if="firstLoad"></circle-spin>
            <div v-else>
                <div class="row mb-10 no-margin card card-body">
                    <h5>Welcome!</h5>
                    <p>We’re glad to have you! There are lots of people who don’t have anyone to talk to. On Fitila, you will help to
                        provide a safe space for people to talk anonymously about what they’re going through.<br>
                        These trainings take around 30 minutes to complete. If you have to stop part way, just log back in to continue.
                    </p>
                    <p>Email us at <strong>support@mentalcare.life</strong> if you have any questions. Good luck!</p>
                </div>
                <div class="row" v-if="trainings.length > 0">
                    <div class="col-sm-6 col-md-4 col-xl-3" v-for="(training, index) in trainings" :key="index">
                        <div class="card card-body">
                            <div>
                                <span class="ion-ios-list-outline text-primary fs-60"></span>
                            </div>
                            <h5 class="text-uppercase">{{training.title}}</h5>
                            <p>Sub-topics: {{training.sub_topics.length}}</p>
                            <div class="flexbox justify-content-start">
                            <router-link v-if="passed_trainings.length > 0" :to="'/listener/training/'+ training.id+'&'+passed_trainings[index].listener_training.completed" tag="a" class="btn btn-xs btn-primary text-uppercase">
                                Take Course
                            </router-link> 
                            <router-link v-else :to="'/listener/training/'+ training.id" tag="a" class="btn btn-xs btn-primary text-uppercase">
                                Take Course
                            </router-link>
                            <!-- Add v-if condition to hide this if user has passed test for this training -->
                            <button v-if="passed_trainings.length > 0 && passed_trainings[index].title == training.title" class="btn btn-xs bg-1 text-uppercase" disabled>Passed</button>
                            <router-link 
                                v-else
                                :to="'/listener/test/'+training.title +'&'+training.id" 
                                tag="a" class="btn btn-xs bg-1 text-uppercase">
                                Take Test 
                            </router-link>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div v-else class="card card-body p-50 text-center">
                        <div class="pb-10">
                            <i class="fs-svg ion-ios-list"></i>
                        </div>
                        <div class="mb-10">
                            <h5> There are no trainings available.</h5>
                            Check back later.<br>
                        </div>
                    </div>  
            </div>
        </div>
    </main>
</template>
<script>
import axios from 'axios'
import allMixins from '../../mixins.js'

export default {
    mixins: [allMixins],
    data() {
        return {
            firstLoad: true,
            trainings: [],
            passed_trainings: []
        }
    },
    mounted() {
        let details = this.$jwt.decode(this.retrieveToken(window.btoa('userToken')), "inGXVHWPU9BB5q2oix1r-zaA")
        axios.get("/admin/list?type=training")
        .then(res => {
            this.trainings = res.data.data
            axios.get(`users/find/${details.id}`)
            .then(res => {
                let listener_id = res.data.listener[0].id
                axios.get(`/admin/training/complete?listenerId=${listener_id}`)
                .then(res => {
                            this.firstLoad = false;
                            // console.log(res)
                            if(res.data.data.length > 0){
                                this.passed_trainings = res.data.data[0].trainings
                            }
                })
                .catch(err => {
                            this.firstLoad = false;
                            this.$notify({
                                group: 'response',
                                type: 'error',
                                text:  `${err.response.data.message}`,
                                duration: 5000
                            })
                })
            })
             .catch(err => {
                this.firstLoad = false;
                this.$notify({
                    group: 'response',
                    type: 'error',
                    title:  `${err.response.data.message}`,
                    duration: 5000
                });
            })
    })
    .catch(err => {
            this.firstLoad = false;
            this.$notify({
                group: 'response',
                type: 'error',
                title:  `${err.response.data.message}`,
                duration: 5000
            });
        })
  }
}
</script>